import { useState, useEffect, useCallback } from 'react';
import { Form, Button, Col, Row, Card, InputGroup } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FaUser, FaEnvelope, FaBuilding } from 'react-icons/fa';
import FormContainer from '../components/FormContainer';
import { saveShippingAddress } from '../slices/cartSlice';
import CheckoutStatusBar from '../components/CheckoutStatusBar.jsx';
import countryTR from '../assets/styles/countryTR.js';

const UserFill = () => {
  const cart = useSelector((state) => state.cart);
  const { shippingAddress } = cart;

  const [companyCity, setCompanyCity] = useState(shippingAddress?.companyCity || '');
  const [city, setCity] = useState(shippingAddress?.companyCity || '');
  
  const [cities, setCities] = useState(
    countryTR.find(ctr => ctr.il === `${shippingAddress?.companyState ? shippingAddress.companyState : 'Seçiniz'}`)?.ilceleri || ''
  );
  const [companyState, setCompanyState] = useState(shippingAddress?.companyState || '');
  const [state, setState] = useState(shippingAddress?.companyState || '');
  const [address, setAddress] = useState(shippingAddress?.companyAddress || '');
  const [companyName, setCompanyName] = useState(shippingAddress?.companyName || '');
  const [companyAddress, setCompanyAddress] = useState(shippingAddress?.companyAddress || '');
  const [receiver, setReceiver] = useState(shippingAddress?.receiver || '');
  const [name, setName] = useState(shippingAddress?.name || '');
  const [surname, setSurname] = useState(shippingAddress?.surname || '');
  const [email, setEmail] = useState(shippingAddress?.email || '');
  const [phoneNumber, setPhoneNumber] = useState(shippingAddress?.phoneNumber || '');
  const [idNumber, setIdNumber] = useState(shippingAddress?.idNumber || '11111111111');
  const [taxNumber, setTaxNumber] = useState(shippingAddress?.taxNumber || '');
  const [taxState, setTaxState] = useState(shippingAddress?.taxState || '');
  
  const [isCompany, setIsCompany] = useState(shippingAddress?.isCompany || 'false');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [chng, setchng] = useState('');

  const submitHandler = (e) => {
    e.preventDefault();
    setFormErrors(validate());
    setIsSubmit(true);
  };

  const validate = () => {
    const errors = {};
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (!name) errors.name = "Adınızı giriniz";
    if (!surname) errors.surname = "Soyadınızı giriniz";
    if (!email) {
      errors.email = "E-posta adresinizi giriniz";
    } else if (!regex.test(email)) {
      errors.email = "Geçersiz e-posta formatı";
    }
    if (!phoneNumber) errors.phoneNumber = "Telefon numarası giriniz";
    if (!companyCity) errors.companyCity = "İlçeyi seçiniz";
    if (companyState === "Seçiniz" || !companyState) errors.companyState = "Şehri seçiniz";
    if (!companyAddress) errors.companyAddress = "Açık adresi giriniz";
    
    if (isCompany === "true") {
      if (!taxState) errors.taxState = "Vergi Dairesini giriniz";
      if (!taxNumber) errors.taxNumber = "Vergi Numarasını giriniz";
      if (!companyName || companyName.trim() === "") errors.companyName = "Firma Adını giriniz";
    }
    return errors;
  };
  const submitHandler2 = useCallback(() => {
    setchng(" ");
    dispatch(saveShippingAddress({
      companyCity, companyState, companyName, companyAddress, address, 
      state, city, receiver, name, surname, email, phoneNumber, 
      idNumber, taxNumber, taxState, isCompany
    }));
    navigate('/shipping');
  }, [dispatch, navigate, companyCity, companyState, companyName, companyAddress, address, state, city, receiver, name, surname, email, phoneNumber, idNumber, taxNumber, taxState, isCompany]);

  const submitHandler1 = useCallback(() => {
    if (isCompany === "true") {
      setIdNumber(" ");
    } else {
      if (!idNumber) setIdNumber(" ");
      if (!companyName || companyName.trim() === " ") setCompanyName(`${name} ${surname}`);
      setTaxNumber(" ");
      setTaxState(" ");
    }
    setchng("1");
  }, [isCompany, idNumber, companyName, name, surname]);

  useEffect(() => {
    if (chng === "1") {
      submitHandler2();
    }
  }, [chng, submitHandler2]);

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      submitHandler1();
    }
  }, [formErrors, isSubmit, submitHandler1]);

  useEffect(() => {
    if (isCompany === "true") {
      setTaxNumber("");
      setTaxState("");
    }
  }, [isCompany]);

  const changeState = (e) => {
    setCompanyState(e.target.value);
    setState(e.target.value);
    const foundState = countryTR.find(ctr => ctr.il === e.target.value);
    if (foundState) {
      setCities(foundState.ilceleri);
      setCity(foundState.ilceleri);
      setCompanyCity(foundState.ilceleri);
    }
  };

  return (
    /* 
       REVIZYON: Üst boşluk 280px'den 180px'e düşürülerek, 
       CheckoutStatusBar ve içerik üstteki menü barına (sidebar/header) daha çok yaklaştırıldı.
    */
    <div style={{ paddingTop: '10px', paddingBottom: '10px', backgroundColor: '#f8f9fa' }}>
      <FormContainer>
        <CheckoutStatusBar step1 />
        
        {/* REVIZYON: Kart başlığı gri (bg-dark) yerine şirketinizin ana logo rengi (#004488) yapıldı */}
        <Card  className="border-0 shadow-sm rounded-4 overflow-hidden mb-4" 
  style={{ 
    borderTop: '4px solid #004488',
    marginTop: '40px',    // Negatif margin ile aradaki dikey beyaz boşluk tamamen kapatıldı
    position: 'relative',
    zIndex: 0
  }}>
          <Card.Header className="text-white p-3 border-0" style={{ backgroundColor: '#66CCFF' }}>
            <h4 className="m-0 fw-bold fs-5 d-flex align-items-center gap-2">
              <FaUser /> İletişim ve Fatura Bilgileri
            </h4>
          </Card.Header>
          <Card.Body className="p-4 bg-white">
            <Form onSubmit={submitHandler}>
              
              <Row>
                <Col xs={12} md={6}>
                  <Form.Group controlId='name' className='mb-3'>
                    <Form.Label className="fw-bold text-muted small">Adı</Form.Label>
                    <Form.Control
                      type='text'
                      placeholder='Adınızı giriniz'
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                        if (isCompany === 'false') {
                          setCompanyName(`${e.target.value} ${surname}`);
                          setReceiver(`${e.target.value} ${surname}`);
                        }
                      }}
                      className="py-2 rounded-3 border-secondary-subtle"
                    />
                    {formErrors.name && <small className="text-danger d-block mt-1 font-monospace">{formErrors.name}</small>}
                  </Form.Group>
                </Col>
                
                <Col xs={12} md={6}>
                  <Form.Group controlId='surname' className='mb-3'>
                    <Form.Label className="fw-bold text-muted small">Soyadı</Form.Label>
                    <Form.Control
                      type='text'
                      placeholder='Soyadınızı giriniz'
                      value={surname}
                      onChange={(e) => {
                        setSurname(e.target.value);
                        if (isCompany === 'false') {
                          setCompanyName(`${name} ${e.target.value}`);
                          setReceiver(`${name} ${e.target.value}`);
                        }
                      }}
                      className="py-2 rounded-3 border-secondary-subtle"
                    />
                    {formErrors.surname && <small className="text-danger d-block mt-1 font-monospace">{formErrors.surname}</small>}
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col xs={12} md={6}>
                  <Form.Group controlId='email' className='mb-3'>
                    <Form.Label className="fw-bold text-muted small">E-Posta Adresi</Form.Label>
                    <InputGroup>
                      <InputGroup.Text className="bg-light border-secondary-subtle"><FaEnvelope className="text-muted" /></InputGroup.Text>
                      <Form.Control
                        type='email'
                        placeholder='ornek@firma.com'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="py-2 rounded-end-3 border-secondary-subtle"
                      />
                    </InputGroup>
                    {formErrors.email && <small className="text-danger d-block mt-1 font-monospace">{formErrors.email}</small>}
                  </Form.Group>
                </Col>
                
                <Col xs={12} md={6}>
                  <Form.Group controlId='phonenumber' className='mb-3'>
                    <Form.Label className="fw-bold text-muted small">Cep Telefonu</Form.Label>
                    <InputGroup>
                      <InputGroup.Text className="bg-light border-secondary-subtle font-monospace fw-bold" style={{ fontSize: '0.9rem' }}>+90</InputGroup.Text>
                      <Form.Control
                        type='tel'
                        placeholder='5XXXXXXXXX'
                        value={phoneNumber}
                        onChange={(e) => e.target.value.length < 11 && setPhoneNumber(e.target.value)}
                        className="py-2 rounded-end-3 border-secondary-subtle font-monospace"
                      />
                    </InputGroup>
                    {formErrors.phoneNumber && <small className="text-danger d-block mt-1 font-monospace">{formErrors.phoneNumber}</small>}
                  </Form.Group>
                </Col>
              </Row>
              <div className="my-4 p-3 bg-light rounded-3 border">
                <Form.Label className="fw-bold text-dark d-block mb-2">Müşteri Türü</Form.Label>
                <div className="d-flex gap-4">
                  <Form.Check
                    type='radio'
                    id='isCompanyFalse'
                    name='isCompany'
                    label={<span className="fw-bold text-secondary" style={{ cursor: 'pointer' }}><FaUser className="me-1" /> Bireysel</span>}
                    value='false'
                    checked={isCompany === 'false'}
                    onChange={(e) => setIsCompany(e.target.value)}
                  />
                  <Form.Check
                    type='radio'
                    id='isCompanyTrue'
                    name='isCompany'
                    label={<span className="fw-bold text-secondary" style={{ cursor: 'pointer' }}><FaBuilding className="me-1" /> Kurumsal</span>}
                    value='true'
                    checked={isCompany === 'true'}
                    onChange={(e) => setIsCompany(e.target.value)}
                  />
                </div>
              </div>

              <Form.Group controlId='companyName' className='mb-3'>
                <Form.Label className="fw-bold text-muted small">Fatura Ünvanı / Adı Soyadı</Form.Label>
                <Form.Control
                  type='text'
                  placeholder='Faturada görünecek ünvan veya ad soyad'
                  value={companyName}
                  onChange={(e) => {
                    setCompanyName(e.target.value);
                    setReceiver(e.target.value);
                  }}
                  className="py-2 rounded-3 border-secondary-subtle fw-semibold"
                />
                {formErrors.companyName && <small className="text-danger d-block mt-1 font-monospace">{formErrors.companyName}</small>}
              </Form.Group>

              {isCompany === 'true' ? (
                <Row className="p-3 mb-3 border rounded-3 bg-body-tertiary">
                  <h6 className="fw-bold text-dark mb-3"><FaBuilding className="me-1" /> Şirket Resmi Bilgileri</h6>
                  <Col xs={12} md={6}>
                    <Form.Group controlId='taxNumber' className='mb-2'>
                      <Form.Label className="fw-bold text-muted small">Vergi Numarası</Form.Label>
                      <Form.Control
                        type='text'
                        placeholder='10 Haneli Vergi No'
                        value={taxNumber}
                        onChange={(e) => setTaxNumber(e.target.value)}
                        className="py-2 rounded-3 border-secondary-subtle font-monospace"
                      />
                      {formErrors.taxNumber && <small className="text-danger d-block mt-1 font-monospace">{formErrors.taxNumber}</small>}
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Group controlId='taxState' className='mb-2'>
                      <Form.Label className="fw-bold text-muted small">Vergi Dairesi</Form.Label>
                      <Form.Control
                        type='text'
                        placeholder='Bağlı Olunan Vergi Dairesi'
                        value={taxState}
                        onChange={(e) => setTaxState(e.target.value)}
                        className="py-2 rounded-3 border-secondary-subtle"
                      />
                      {formErrors.taxState && <small className="text-danger d-block mt-1 font-monospace">{formErrors.taxState}</small>}
                    </Form.Group>
                  </Col>
                </Row>
              ) : (
                <Row className="p-3 mb-3 border rounded-3 bg-body-tertiary">
                  <Col md={12}>
                    <Form.Group controlId='idNumber' className='mb-2'>
                      <Form.Label className="fw-bold text-muted small">TCK/VKN</Form.Label>
                      <Form.Control
                        type='text'
                        placeholder='11 Haneli TCK/VKN No'
                        value={idNumber}
                        onChange={(e) => setIdNumber(e.target.value)}
                        className="py-2 rounded-3 border-secondary-subtle font-monospace"
                      />
                    </Form.Group>
                  </Col>
                </Row>
              )}

              <Row>
                <Col xs={12} md={6}>
                  <Form.Group controlId='companyState' className='mb-3'>
                    <Form.Label className="fw-bold text-muted small">İl</Form.Label>
                    <Form.Select value={companyState} onChange={changeState} className="py-2 rounded-3 border-secondary-subtle" style={{ cursor: 'pointer' }}>
                      <option value="Seçiniz">Seçiniz</option>
                      {countryTR.map((ctr) => (
                        <option key={ctr.il} value={ctr.il}>{ctr.il}</option>
                      ))}
                    </Form.Select>
                    {formErrors.companyState && <small className="text-danger d-block mt-1 font-monospace">{formErrors.companyState}</small>}
                  </Form.Group>
                </Col>

                <Col xs={12} md={6}>
                  <Form.Group controlId='companyCity' className='mb-3'>
                    <Form.Label className="fw-bold text-muted small">İlçe</Form.Label>
                    <Form.Select
                      value={companyCity}
                      onChange={(e) => {
                        setCompanyCity(e.target.value);
                        setCity(e.target.value);
                      }}
                      className="py-2 rounded-3 border-secondary-subtle"
                      style={{ cursor: 'pointer' }}
                      disabled={!cities}
                    >
                      {cities && cities.map((cityOpt) => (
                        <option key={cityOpt} value={cityOpt}>{cityOpt}</option>
                      ))}
                    </Form.Select>
                    {formErrors.companyCity && <small className="text-danger d-block mt-1 font-monospace">{formErrors.companyCity}</small>}
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <Form.Group controlId='companyAddress' className='mb-3'>
                    <Form.Label className="fw-bold text-muted small">Fatura ve Sevk Adresi</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder='Mahalle, Sokak, No, Daire bilgilerini eksiksiz yazınız.'
                      value={companyAddress}
                      onChange={(e) => {
                        setCompanyAddress(e.target.value);
                        setAddress(e.target.value);
                      }}
                      className="rounded-3 border-secondary-subtle"
                    />
                    {formErrors.companyAddress && <small className="text-danger d-block mt-1 font-monospace">{formErrors.companyAddress}</small>}
                  </Form.Group>
                </Col>
              </Row>

              {/* REVIZYON: Buton tasarımı Header'daki "Ara" butonuyla tamamen aynı özelliklere kavuşturuldu */}
              <Button 
                type='submit' 
                className='w-100 border-0 fw-bold transition-all shadow-sm' 
                style={{ 
                  backgroundColor: '#2b2b2b', // Başlangıç rengi koyu gri
                  color: '#ffffff',
                  height: '46px',
                  borderRadius: '4px',
                   fontSize: '1.1rem',
                  transition: 'all 0.2s ease-in-out'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#66CCFF'} // Üzerine gelince açık mavi (#66CCFF)
                onMouseLeave={(e) => e.target.style.backgroundColor = '#2b2b2b'} // Ayrılınca eski renk
              >
                Bilgileri Kaydet ve Devam Et
              </Button>
            </Form>
          </Card.Body>
        </Card>
      </FormContainer>
    </div>
  );
};

export default UserFill;
